<template>
	<div class="embedded">
		<Card v-if="card" :embedded="true" :card="card" :layer="card.layer" :key="card.id" />
	</div>
</template>

<script>
import axios from 'axios'
import Card from '@/components/Card.vue'

export default {
	name: 'EmbeddedCard',

	components: { Card },

	data() {
		return {
			card: null
		}
	},

	mounted() {
		const url = this.$apiUrl + '/api/embedded-card'
			+ '/' + this.$route.params.clientId
			+ '/' + this.$route.params.cardId
			+ '/' + this.$route.params.slug;

		axios.get(url).then(res => {
			this.card = res.data.card

			console.log(this.card)
		})
	}
}
</script>
